import
  React, {
  useContext
} from 'react';

import
  styled
from 'styled-components';

import {
  Text,
  VContainerVH
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../constants';

import {
  AppContext
} from 'context';

const TextWithLink = styled(Text)`
  font-size: 14px;
  text-align: center;
  font-weight: 300;
  color:${CustomColors.White};
  padding:0;
  a {
    color: white;
  }
`;

export const TopBanner = props => {

  const { config } = useContext(AppContext);

  return (
    <>
    { config?.topBannerContent && config?.enableTopBanner === true &&

      <VContainerVH
        backgroundColor={CustomColors.Blue6}
        padding='0 32px 0 33px'>

        <TextWithLink
          dangerouslySetInnerHTML={{
            __html: config?.topBannerContent
          }}/>

      </VContainerVH>
    }
    </>
  );
};